import { render, staticRenderFns } from "./noFeedback.vue?vue&type=template&id=7a65e25c&scoped=true"
import script from "./noFeedback.vue?vue&type=script&lang=js"
export * from "./noFeedback.vue?vue&type=script&lang=js"
import style0 from "./noFeedback.vue?vue&type=style&index=0&id=7a65e25c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a65e25c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a65e25c')) {
      api.createRecord('7a65e25c', component.options)
    } else {
      api.reload('7a65e25c', component.options)
    }
    module.hot.accept("./noFeedback.vue?vue&type=template&id=7a65e25c&scoped=true", function () {
      api.rerender('7a65e25c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feedbackStatistics/components/noFeedback.vue"
export default component.exports